<span class="text">
  <ng-content></ng-content>
</span>
@if (icon) {
  <vee-icon [icon]="icon" [weight]="iconWeight"/>
}